import {CHANGE_MESSAGE} from './constants';
import initialState from './state';

export default function HelloWorldReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_MESSAGE:
      return {...state, message: action.message};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/HelloWorld/reducer.js